import grey from '@material-ui/core/colors/grey';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		menuAppBar: {
			top: 'auto',
			bottom: 0,
			background: 'white',
			boxShadow: theme.custom.defaultBoxShadow,
			borderRadius: '16px 16px 0px 0px',
			zIndex: 1350
		},
		menuListItem: {
			fontSize: 14,
			padding: '15px 30px',
			'&:last-child .showroomMobileMediaMenuListItemInnerWrapper': {
				borderBottom: 'none',
				paddingBottom: 12
			}
		},
		subListCollapse: {
			background: grey[100],
			boxShadow: 'inset 0px -5px 5px rgba(0, 0, 0, 0.03), inset 0px 5px 10px rgba(0, 0, 0, 0.07)'
		},
		subList: {
			paddingLeft: 30,
			paddingRight: 30
		},
		subListItem: {
			paddingLeft: 56
		},
		listItemInnerWrapper: {
			display: 'flex',
			flex: 1,
			alignItems: 'center',
			paddingBottom: 15,
			borderBottom: `1px solid ${grey[300]}`
		},
		listItemIcon: {
			fontSize: 24,
			color: 'black'
		},
		listItemText: {
			fontSize: 14
		},
		loader: {
			marginRight: 32,
			color: grey[500]
		}
	};
});
